export default __webpack_public_path__ + "static/media/tokenomic.19b2e6b1.svg";